import { render } from "./TransactionPage.vue?vue&type=template&id=13adf4a8&scoped=true&ts=true"
import script from "./transaction.component.ts?vue&type=script&lang=ts"
export * from "./transaction.component.ts?vue&type=script&lang=ts"

import "./transactionPage.scss?vue&type=style&index=0&id=13adf4a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/e-wallet-fe/e-wallet-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13adf4a8"]])

export default __exports__